import React from "react";
import { ShieldCheck, Users, PoundSterling, Clock, Package, Building2, HeartHandshake, BadgeCheck, Sparkles } from "lucide-react";

const reasons = [
  { icon: ShieldCheck, title: "Fully Insured", desc: "Complete cover on every move for total peace of mind." },
  { icon: Users, title: "Reliable Team", desc: "Trained, uniformed and background-checked movers." },
  { icon: PoundSterling, title: "Affordable Pricing", desc: "Fair, transparent quotes — no hidden charges." },
  { icon: Clock, title: "Same Day Availability", desc: "Last-minute moves handled with a smile." },
  { icon: Package, title: "Professional Packing", desc: "Fragile-safe packing with premium materials." },
  { icon: Building2, title: "Office Specialists", desc: "Minimum downtime for business relocations." },
  { icon: HeartHandshake, title: "Friendly Service", desc: "Real people who genuinely care about your move." },
  { icon: BadgeCheck, title: "No Hidden Charges", desc: "The quote you receive is the price you pay." },
  { icon: Sparkles, title: "5-Star Customer Service", desc: "Rated by families & businesses across South Wales." },
];

export const WhyChoose = () => (
  <section id="why" data-testid="why-section" className="py-20 md:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
        <div className="lg:col-span-6">
          <span className="text-xs tracking-[0.22em] uppercase font-bold text-[#2563EB]">Why Choose BoxB</span>
          <h2 className="mt-4 font-display font-semibold text-[#0A192F] text-4xl sm:text-5xl tracking-tight">
            Movers Cardiff trusts. <br className="hidden md:block" /> Service you&apos;ll recommend.
          </h2>
        </div>
        <p className="lg:col-span-6 text-lg text-slate-600 leading-relaxed">
          BoxB Solutions was built on one idea: moving should be simple. Fixed pricing, careful handling, and a friendly team from the first call to the final box. Movers Cardiff loves.
        </p>
      </div>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {reasons.map((r) => {
          const I = r.icon;
          return (
            <div
              key={r.title}
              data-testid={`why-item-${r.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="hover-lift rounded-3xl border border-slate-200 bg-white p-7"
            >
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-[#F8FAFC] text-[#2563EB]">
                <I className="h-5 w-5" strokeWidth={1.75} />
              </span>
              <h3 className="mt-5 font-display font-semibold text-xl text-[#0A192F]">{r.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{r.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
